// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"839f4949","503":"2d026c98","963":"5d0cc92a"}[chunkId] + ".chunk.js";
};